import React from 'react';

export default function WarningIcon({ color }) {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0163 15.8C29.7868 12.7333 34.2132 12.7333 35.9837 15.8L51.5722 42.8C53.3427 45.8667 51.1295 49.7 47.5885 49.7H16.4116C12.8705 49.7 10.6573 45.8667 12.4278 42.8L28.0163 15.8ZM34.9445 16.4C33.6358 14.1333 30.3642 14.1333 29.0555 16.4L13.4671 43.4C12.1584 45.6667 13.7942 48.5 16.4116 48.5H47.5885C50.2058 48.5 51.8416 45.6667 50.533 43.4L34.9445 16.4Z"
        fill={color}
      />
      <rect x="31" y="25.0996" width="2" height="12" fill={color} />
      <circle cx="32" cy="41.5996" r="1.5" fill={color} />
    </svg>
  );
}
